module.exports = __webpack_public_path__ + "img/placeholder_UB.6900d194.jpg";